import jwt_decode from 'jwt-decode';

/**
 * Checks whether the current session JWT (sessionStorage['token']) carries the
 * `finxone-admin` realm role. Single home for the check used by AdminGuard,
 * left-menus and the infrastructure route — API security is the real boundary,
 * this is cosmetic gating only (ADR-9).
 */
export function hasFinxoneAdminRole(): boolean {
  const token = sessionStorage.getItem('token');
  if (!token) {
    return false;
  }

  try {
    const jwt = jwt_decode(token) as { realm_access?: { roles?: string[] } };
    return jwt.realm_access?.roles?.includes('finxone-admin') ?? false;
  } catch (error) {
    console.error('Error decoding token:', error);
    return false;
  }
}
